import { render } from "./parts.vue?vue&type=template&id=75b7e9d7&scoped=true"
import script from "./parts.vue?vue&type=script&lang=js"
export * from "./parts.vue?vue&type=script&lang=js"

import "./parts.vue?vue&type=style&index=0&id=75b7e9d7&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b7e9d7"]])

export default __exports__